import styled from 'styled-components'

export const Container = styled.div`
  border-top: 1px solid ${props => props.theme.palette.general.borderColor};
  border-bottom: 1px solid ${props => props.theme.palette.general.borderColor};

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
`
